// ポール表示関連の型定義
// fork_webapp_react の src/types/ros.ts (PoleNs / CategorizedPole / MapPole) に対応

/** ポール種別を表す namespace（laser_localization の RViz マーカー ns と同じ） */
export type PoleNs =
  | 'detected_pole_matched' // ポールマップに正しくマッチ
  | 'detected_pole_unmatched' // マップから外れた位置（自己位置推定に未使用）
  | 'detected_pole_excluded_ransac' // マップからズレと判定され除外
  | 'detected_pole_excluded_multiple_match' // 1本に複数マッチで除外（ゴースト等）
  | 'detected_pole_excluded_masked_area' // マスクエリア内のため除外

export interface CategorizedPole {
  x: number
  y: number
  ns: PoleNs | string
}

/** ポールマップ（laser_localization が CSV から読み込む静的ランドマーク）の1本 */
export interface MapPole {
  x: number
  y: number
}

/** バケットに保存される検出ポールのスナップショット */
export interface PoleSnapshot {
  timestamp: string
  poles: CategorizedPole[]
}

/** GET /pole-map のレスポンス */
export interface PoleMapResponse {
  poles: MapPole[] | null
  timestamp: string | null
  site_id: string | null
}

// バケット保存時の ns 短縮コード → ns 復元表
// （terraform/modules/data-buckets/lambda-src/rollup-30min.js の POLE_NS_TO_CODE と同期）
const POLE_NS_BY_CODE: Record<string, PoleNs> = {
  m: 'detected_pole_matched',
  u: 'detected_pole_unmatched',
  er: 'detected_pole_excluded_ransac',
  em: 'detected_pole_excluded_multiple_match',
  ek: 'detected_pole_excluded_masked_area',
}

export function decodePoleNs(ns: string): string {
  return POLE_NS_BY_CODE[ns] ?? ns
}
